import BasicLink from 'core/BasicLink';
import FullWrapper from 'core/FullWrapper';
import ScrollAnimation from 'core/ScrollAnimation';
import NewProject from 'shared/sections/NewProjectContainer/NewProject';

import cn from './style.module.sass';

type CurrentListProps = {
    currentList: CurrentListItem[];
    detailLink?: boolean;
};

type CurrentListItem = {
    router?: string;
    newImg?: string;
    oldImg?: string;
    icons?: IconsItems[] | [];
    video?: string;
    title: string;
    description: string;
};

type IconsItems = {
    icon?: string;
};

export default function NewProjectContainer({ currentList, detailLink = false }: CurrentListProps) {
    return (
        <ScrollAnimation>
            <FullWrapper caseName={cn['case-container']}>
                <div className={cn['projects__container']}>
                    {currentList.map(
                        ({ newImg, oldImg, title, description, router, video, icons }) => {
                            return (
                                <ScrollAnimation key={title}>
                                    {router ? (
                                        <div className={cn['projects__container-list']}>
                                            <BasicLink key={title} href={router}>
                                                <NewProject
                                                    newImg={newImg}
                                                    oldImg={oldImg}
                                                    title={title}
                                                    description={description}
                                                    video={video}
                                                    icons={icons}
                                                />
                                            </BasicLink>
                                        </div>
                                    ) : (
                                        <div className={cn['projects__container-list']}>
                                            <NewProject
                                                newImg={newImg}
                                                oldImg={oldImg}
                                                title={title}
                                                description={description}
                                                video={video}
                                                icons={icons}
                                            />
                                        </div>
                                    )}
                                </ScrollAnimation>
                            );
                        }
                    )}
                </div>
                {detailLink && (
                    <BasicLink href={'/cases'} className={cn['projects__container-link']}>
                        Все кейсы
                    </BasicLink>
                )}
            </FullWrapper>
        </ScrollAnimation>
    );
}
